import type { FC } from 'react';

/** A colour plus what that colour MEANS — a dot is useless without the second half. */
export type StatusDotSpec = { className: string; title: string };

/**
 * A small status dot. Shared by the tab strip and by tables so one status looks the same wherever
 * it's shown; the colour itself comes from whatever domain map defines the statuses (e.g. GUIDE_DOTS).
 */
export const StatusDot: FC<{ dot: StatusDotSpec; className?: string }> = ({ dot, className }) => (
    <span
        // A bare span has no role, so the dot needs one before it can carry a label.
        role="img"
        aria-label={dot.title}
        title={dot.title}
        className={`inline-block size-2 shrink-0 rounded-full align-middle ${dot.className} ${className ?? ''}`}
    />
);
